import React from "react";
import { HorizontalBar } from "react-chartjs-2";
import { horizontalBar } from "./_commonSharedChartOptions";
import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  WidgetLoading,
  WidgetNoDataToDisplay,
  WidgetServerError
} from "../../../../components/DashboardWidget/WidgetCommon";
import { AVGNumberOfUtterancesPerSessionDataPreview, sessionsByUserDataPreview } from "./_previewData";

const widgetProps = {
  Chart: "AVERAGE_NUMBER_OF_UTTERANCES_PER_SESSION_AT_USER_LEVEL",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

class AVGNumberOfUtterancesPerSessionContentClass extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { widgetData, draggable } = this.props;
    return (
      <div>
        <div className="widgetTitle">AVG Num Of Req Per Session</div>
        <div className="widgetTitleDescription">AVG Number of requests per session</div>
        <div className="widgetBody">
          {widgetData /*&& !this.state.loading*/ ? (
            widgetData.code !== 200 || draggable ? (
              <WidgetServerError draggable={draggable} />
            ) : widgetData.chart_data.data_dict.Items.length === 0 || draggable ? (
              <WidgetNoDataToDisplay draggable={draggable} />
            ) : (
              <HorizontalBar
                id={widgetProps.Chart}
                data={{
                  labels: widgetData.chart_data.labels,
                  datasets: widgetData.chart_data.data_dict.Items
                }}
                options={horizontalBar}
              />
            )
          ) : (
            <WidgetLoading />
          )}
        </div>
      </div>
    );
  }
}

export const AVGNumberOfUtterancesPerSessionPreview = () => {
  return (
    <div>
      <div className="widgetTitle">AVG Num Of Req Per Session</div>
      <div className="widgetBody">
        <HorizontalBar
          data={AVGNumberOfUtterancesPerSessionDataPreview}
          options={_.merge({}, horizontalBar, {
            legend: { display: false },
            scales: {
              yAxes: [
                {
                  ticks: {
                    fontSize: 5
                  }
                }
              ]
            },
            plugins: {
              datalabels: {
                font: {
                  size: 5
                }
              }
            }
          })}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    widgetData: state.dashboard[widgetProps.Chart],
    dashboardDates: state.dashboard.widgetFromToDate,
    skill: state.skill
  };
}

export const AVGNumberOfUtterancesPerSessionContent = connect(
  mapStateToProps,
  undefined
)(AVGNumberOfUtterancesPerSessionContentClass);
